import { useMemo } from 'react';

import * as Styled from './event.style';

export const useTimeBasedStyle = (startDate?: string, endDate?: string) =>
  useMemo(() => {
    if (!startDate || !endDate) {
      return {
        marginTop: Styled.maxTopMargin,
        lineHeight: Styled.maxLineHeight,
      };
    }

    const timeDiff =
      new Date(endDate).getTime() - new Date(startDate).getTime();
    const maxTimeDiff = 20 * 60 * 1000; // 15 minutes in milliseconds
    return {
      marginTop: Math.min(
        Styled.maxTopMargin,
        (timeDiff / maxTimeDiff) * Styled.maxTopMargin,
      ),
      lineHeight: Math.min(1.5, 1 + (timeDiff / maxTimeDiff) * 0.5),
    };
  }, [endDate, startDate]);
